<template>
  <div
    v-if="
      cart.isLoyaltyEnabled ||
      (cart.promoThresholdMoney !== -1 && contentSlots['cart-promos'] && Object.keys(contentSlots['cart-promos']).length)
    "
    class="promo-container"
  >
    <!-- Free Shipping -->
    <div
      v-if="cart.promoThresholdMoney !== -1 && contentSlots['cart-promos'] && Object.keys(contentSlots['cart-promos']).length"
      class="free-shipping-container"
    >
      <div class="free-shipping-progress-bar">
        <span id="spent-progress-bar" class="spent" :style="spentMoneyBarStyle">
        </span>
        <span class="remaining"> </span>
      </div>
      <div v-if="!isFreeShippingEligible" class="message">
        <span
          v-if="cart && cart.totals && cart.totals.shippingRewardMsg"
          v-html="
            $t(contentSlots['cart-promos']['cart-free-shipping'], [
              cart.totals.shippingRewardMsg.resources.thresholdMoneyToBeSpent,
            ])
          "
        ></span>
      </div>

      <div v-else class="message">
        <span
          v-html="$t(contentSlots['cart-promos']['cart-free-shipping-qualify'])"
        ></span>
      </div>
    </div>

    <!-- Fresh Rewards Promo -->
    <div v-if="cart.isLoyaltyEnabled && showEarningPoints" class="fresh-rewards-promo-container">
      <img class="reward-star" :src="svgIcon('reward-star')" alt="" />
      <!-- label.fresh.rewards.sign.join = Earn <span class="{0}>{1}</span> points <span class="{2}">with your purchase today.</span> -->

      <div v-if="isCustomerAuthenticated" class="message-wrapper">
        <span v-html="$t('earningPointsTextLogged', {'points': '<span class=\'points font-weight-bold\'>' + rewardPoints + '</span>'})"></span>
      </div>

      <div v-else class="message-wrapper">
        <span v-html="$t('earningPointsTextNotLogged', {'points': '<span class=\'points font-weight-bold\'>' + rewardPoints + '</span>'})"></span>
        <div class="sign-or-join">
          <a
            :href="`${actionURLs['Login-Show']}?rurl=3`"
            v-html="$t('earningPointsSignIn')"
            class="rewards-link-first btn btn-link"
          ></a>
          <span v-html="$t('earningPointsConjunction')" class="normal"></span>
          <a
            :href="`${(passAuthIDEnabled && actionURLs['PassAuthID-CreateAccount']) || (INFOWARE_loyaltyEnable && actionURLs['Account-CreateWitheCRM']) || actionURLs['Account-Create']}?rurl=3`"
            v-html="$t('earningPointsJoinRewards')"
            class="rewards-link-second btn btn-link"
          ></a>
        </div>
      </div>
    </div>

    <!-- Replenishment Promo -->

    <!-- Out of Stock  Promo -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mapGetters as vue3_mapGetters } from "@/store/helper/vuex";
export default {
  name: "PromoContainer",
  components: {},
  setup() {
    const { vueVariables } = vue3_mapGetters();
    return {
        vueVariables
    }
  },
  data() {
    return {
      showEarningPoints: window.vue.customPreferences.showEarningPoints,
      INFOWARE_loyaltyEnable: window.vue.customPreferences.INFOWARE_loyaltyEnable,
      passAuthIDEnabled: window.vue.customPreferences.FRESH_usePassAuthID
    };
  },
  methods: {
    resetAnimation() {
      let el = document.getElementById("spent-progress-bar");
      if (el) {
        el.style.animation = "none";
        el.offsetHeight;
        el.style.animation = null;
      }
    },
  },
  computed: {
    isCustomerAuthenticated: function () {
      return this.vueVariables.isCustomerAuthenticated;
    },
    ...mapState(["actionURLs", "contentSlots"]),
    svgIcon() {
      return (iconName) =>
        `${this.vueVariables.staticImagesFolder}/${iconName}.svg`;
    },
    rewardsMultiplier: function () {
      return this.vueVariables.rewardsMultiplier;
    },
    rewardPoints: function () {
      if (
        this.cart &&
        this.cart.totals &&
        this.cart.totals.shippingRewardMsg &&
        this.cart.totals.adjustedTotalValue
      )
        return Math.ceil(
          this.cart.totals.adjustedTotalValue *
            this.rewardsMultiplier
        );
      return 0;
    },
    ...mapGetters({
      cart: "cart",
      isSOREnabled: "isSOREnabled",
    }),
    isFreeShippingEligible() {
      if (this.isSOREnabled)
        return true;
      if (this.cart && this.cart.totals)
        return this.cart.totals.adjustedTotalValue >=
          this.cart.promoThresholdMoney
          ? true
          : false;
      return false;
    },

    remainingMoney() {
      if (this.isSOREnabled)
        return 100;
      if (this.cart && this.cart.totals) {
        let oneHundredPercent = this.cart.promoThresholdMoney;
        let remainingMoney =
          (100 * this.cart.totals.adjustedTotalValue) / oneHundredPercent;
        return remainingMoney > 100 ? 100 : remainingMoney;
      }
      return 0;
    },

    spentMoneyBarStyle() {
      this.resetAnimation();
      return {
        width: `${this.remainingMoney}%`,
        display: this.remainingMoney == 0 ? "none" : undefined,
        "--remaining-width": `${this.remainingMoney}%`,
      };
    },
  },
  created() {},
};
</script>